import videoReviewStatuses from '@/util/videoReviewStatuses'

export default {
  videoReviewStatuses () {
    return Object.keys(videoReviewStatuses).map(key => {
      return {
        label: videoReviewStatuses[key],
        value: parseInt(key),
      }
    })
  },
}
